var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 0H1.33334C0.599938 0 0 0.599938 0 1.33334V10.6667C0 11.4001 0.599938 12 1.33334 12H10.6667C11.4001 12 12 11.4001 12 10.6667V1.33334C12 0.599938 11.4001 0 10.6667 0ZM4.66666 9.33334L1.33334 6L2.26659 5.06675L4.66666 7.46681L9.73341 2.40006L10.6667 3.33334L4.66666 9.33334Z",
    fill: "#ADB5BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedGrey);
export default __webpack_public_path__ + "static/media/checkedGrey.ec4ae1ee1391d44003022001de6b4bcb.svg";
export { ForwardRef as ReactComponent };